module.exports = __webpack_public_path__ + "img/sc_doodly.cb115e3f.png";